import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import useGradeList from "../../../../../hooks/useGradeList";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { Textarea } from "../../../../Input/Textarea";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

export default function GradeDeleteModal({
  closeEvent,
}: DefaultModalCommonProps) {
  const gradeOptionList = useGradeList();

  const [gradeDropdown, setGradeDropdown] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [reason, setReason] = useState("");
  const [confirmBtnClick, setConfirmBtnClick] = useState(false);
  const [errModal, setErrModal] = useState(false);
  const [deleteAlertModal, setDeleteAlertModal] = useState(false);

  const { response: deleteRespose, error: deleteError } = useApi({
    method: "delete",
    url: confirmBtnClick ? `auth/${gradeDropdown?.value}` : ``,
    data: {
      reason,
    },
  });

  console.log(deleteError);

  useEffect(() => {
    if (deleteRespose?.status === 200) {
      closeEvent();
      toast.success("관리자 등급이 삭제 되었습니다.");
    }
  }, [closeEvent, deleteRespose]);

  useEffect(() => {
    if (deleteError) {
      setErrModal(true);
    }
  }, [deleteError]);

  return (
    <DefaultModalLayout
      isMediumModal={true}
      modalTitle="등급 삭제"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setDeleteAlertModal(true)}
      confirmDisabled={gradeDropdown?.value === "" || reason === ""}
      confirmBtnText="완료"
    >
      <>
        <ModalRow>
          <ModalLabel>관리자 등급 선택</ModalLabel>

          <ModalRowContentContainer>
            <DropDown
              dropdownValue={gradeDropdown}
              setDropDownValue={setGradeDropdown}
              boxWidth={320}
              optionList={gradeOptionList}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <DeleteModalLabel>삭제 사유</DeleteModalLabel>

        <Textarea
          placeholder="삭제 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />

        <>
          {errModal && (
            <AlertModal
              title={`${gradeDropdown?.label} 등급으로 설정된 관리자들이 남아있습니다. 관리자 등급 변경이나 관리자 삭제 후 해당 등급을 삭제해 주세요.`}
              customCancelBtn={<></>}
              confirmEvent={() => setErrModal(false)}
            />
          )}

          {deleteAlertModal && (
            <AlertModal
              title={`${gradeDropdown?.label} 등급이 삭제됩니다. 계속 하시겠습니까?`}
              confirmEvent={() => {
                setDeleteAlertModal(false);
                setConfirmBtnClick(true);
              }}
              cancelEvent={() => setDeleteAlertModal(false)}
            />
          )}
        </>
      </>
    </DefaultModalLayout>
  );
}
